import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Mys from './MYS'
import { OidcService } from './oidcService'
import { setTokenRefresher } from './EntryApi'
//import VeauryVuePlugin from 'veaury/webpack'
import MDI from '@/components/MDI.vue'
import ActionButton from '@/components/ActionButton.vue'
import Dialog from '@/components/Dialog.vue'
import SystemTags from '@/components/fields/SystemTags.vue'
import ExtensionSlot from '@/components/ExtensionSlot.vue'

Vue.config.productionTip = false
console.info(`content-editor build: ${process.env.VUE_APP_BUILD ?? 'local'}`)
//Vue.use(VeauryVuePlugin, { type: 'react' })


// TODO: sentry wrapping destroys the stack trace in the browser
//       figure out a way to do sentry but keeping the dev workflow working
/*Sentry.init({
	Vue,
	// TODO: configure this via env?
	dsn: 'https://7e9d91729ce2267eadbc922cacf55ee0@o4505822393860096.ingest.sentry.io/4505827039772672',
	integrations: [
		new Sentry.BrowserTracing({
			routingInstrumentation: Sentry.vueRouterInstrumentation(router),
		}),
		new Sentry.Replay(),
		// TODO: other integrations?
	],

	// TODO: configure all this via env?
	// ATT: in prod this should be low!
	// 1.0 = capture 100% of transactions for performance monitoring
	tracesSampleRate: 1.0,
	tracePropagationTargets: [
		'localhost',
		/^https:\/\/contentgraph-editor\.lakeside\.peaksolution\.com/,
		/^https:\/\/editor\.staging\.contenthub\.dev/,
		/^https:\/\/editor\.qa\.contenthub\.dev/,
		/^https:\/\/editor\.contenthub\.dev/,
	],
	// 1.0 = capture 100% of replay of all sessions
	replaysSessionSampleRate: 0.0,
	// 1.0 = capture 100% of replay sessions with an error
	replaysOnErrorSampleRate: 0.0,
})*/

let settings = JSON.parse(window.localStorage.settings ?? 'null')
if (!settings) {
	settings = {
		entryTableLength: 10,
		skin: 'default',
	}
}
// the API host is derived from the editor host (editor.X -> cma.X).
// localStorage.baseHost overrides it, e.g. for branch deployments like
// editor.green.contenthub.dev that should talk to an existing backend.
let baseHost = location.host.replace('editor.', '')
if (localStorage.baseHost)
	baseHost = localStorage.baseHost
else if (baseHost.indexOf('localhost') != -1)
	baseHost = 'contenthub.dev' // 'qa.contenthub.dev'
settings.baseEndpoint = 'https://cma.' + baseHost
settings.uploadEndpoint = 'https://upload.' + baseHost
// multiplayer collaboration server (see collab/). Override with
// localStorage.collabHost when running `wrangler dev` locally.
settings.collabHost = localStorage.collabHost || ('collab.' + baseHost)
// the new editor is the default now; opt out with localStorage.multiplayerRte = 'false'.
// This only selects the implementation - it works with or without a collaboration room.
settings.multiplayerRte = localStorage.multiplayerRte != 'false'
// ...and this is the connection switch. Collaboration is not live yet, so the editor
// runs in local (unconnected) mode unless opted in: localStorage.multiplayerRteConnect = 'true'
settings.multiplayerRteConnect = localStorage.multiplayerRteConnect == 'true'
// anchor names on RTE links, while QA works through them: this only hides the
// field in the link dialog. Anchors already in a document keep rendering, and
// editing such a link keeps its anchor whether the flag is on or not.
settings.rteLinkAnchors = localStorage.featureRteLinkAnchors == 'true'

// in a deployed environment we hide some errors that are not relevant
// but on localhost we want to have proper error lines which would break otherwise
if (location.href.indexOf('localhost') != -1) {
	const originalConsoleError = console.error
	console.error = (...args) => {
		if (typeof args[0] == 'string') {
			if (args[0].startsWith('[Vue warn]: Injection "endpoint"')) return
			if (args[0].startsWith('Warning: Function components cannot be given refs.')) return
		}
		originalConsoleError(...args)
	}
}

//let config: { [ key: string ]: any } = {}

async function loadConfig() {
	const isStaging = settings.baseEndpoint.indexOf('.qa.') != -1 || settings.baseEndpoint.indexOf('.staging.') != -1
	const isLocal = location.href.indexOf('localhost:808') != -1

	let config: { [ key: string ]: any } = {}
	if (isLocal) {
		config = {
			FEATURE_LOGIN_KEYCLOAK: 'true',
			FEATURE_OIDC_CLIENT: 'true',
		}
	}
	else {
		try {
			let configUrl = 'https://editor.contenthub.dev/config.json'
			if (isStaging) configUrl = 'https://staging.content-editor.pages.dev/config.json'
			config = await (await fetch(configUrl)).json()
		}
		catch (e) {
			console.warn('Failed to load config. defaults will be used.', e)
		}
	}

	config.isStaging = isStaging
	config.isLocal = isLocal

	let keycloakUrl = 'https://keycloak.production.aws.skiline.cc'
	if (isStaging) keycloakUrl = 'https://keycloak.staging.lakeside.skiline.cc'
	if (isLocal) keycloakUrl = 'https://keycloak.staging.lakeside.skiline.cc'
	config.keycloakUrl = keycloakUrl

	let myservicesUrl = 'https://myservices.alturos.com'
	if (isStaging) myservicesUrl = 'https://myservices.lakeside.peaksolution.com'
	if (isLocal) myservicesUrl = 'http://localhost:8040'
	config.myservicesUrl = myservicesUrl

	return config
}

async function init() {

	const config = await loadConfig()
	;(window as any).config = config

	let token
	let pathname
	const mode = new URLSearchParams(window.location.search).get('mode') ?? 'Standalone'
	if (mode == 'MyServices') {
		if (!document.referrer) {
			alert('Cannot open MyServices mode outside of MyServices')
			throw new Error('no referrer')
		}

		const mys = new Mys(new URL(document.referrer).origin, {
			localeChanged(locale) {
				console.log('localeChanged', locale)
			}
		})

		let [ client, mysUser, config ] = await Promise.all([ mys.getClient(), mys.getUser(), mys.getAppConfig() ])
		console.log('mys', client, mysUser, config)

		// we allow settings to be overridden in the MyServices app settings
		settings = { ...settings, ...config.settings }

		const env = settings.environment || 'master'
		pathname = `/spaces/${client.fields.contentfulSpace.de}/environments/${env}/entries`

		if (!mysUser?.sys?.id) {
			alert('Could not get user from MyServices.')
			throw new Error('No user')
		}

		token = mysUser.kc_token

		// probably an impersonated user -> show a specific error message
		if (!token) {
			alert('Content-Hub does not support MyServices impersonation. Please login with your own account.')
			throw new Error('No token, probably because of impersonation.')
		}

		// The kc_token is short-lived (~5 min). Register a refresher so requests
		// transparently mint a fresh token from the host before it expires.
		setTokenRefresher(async () => {
			try {
				const fresh = await mys.getIdentity()
				if (typeof fresh === 'string' && fresh) return fresh
				// fallback: re-read the user object from the host
				const user = await mys.getUser()
				return user?.kc_token ?? null
			}
			catch (e) {
				console.error('MYS: token refresh failed', e)
				return null
			}
		})

		/*
		// token exchange
		const response = await fetch(settings.baseEndpoint + '/auth/loginWithExternalToken', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				access_token: mysUser.kc_token,
			})
		})
		token = (await response.json()).token

		if (!token) { throw new Error("not auth token")}
		*/
	}
	else if (mode == 'Standalone' && config.FEATURE_OIDC_CLIENT == 'true') {
		console.log('OIDC: Initializing OIDC authentication')

		const oidcService = new OidcService({
			isStaging: config.isStaging,
			isLocal: config.isLocal,
			keycloakUrl: config.keycloakUrl,
		})

		// Store the oidcService globally so MainMenu.vue can access it
		;(window as any).oidcService = oidcService

		// Initialize and get token
		token = await oidcService.initialize()

		if (!token) {
			console.log('OIDC: No valid token, redirecting to login')
			await oidcService.login()
			return
		}

		console.log('OIDC: Successfully authenticated')
		pathname = window.location.pathname
	}
	else if (mode == 'Standalone') {
		// MYS auth uses the query and a 'token' param,
		// the new Keycloak auth uses the hash and 'access_token'
		const query = new URLSearchParams(window.location.search)
		const rawHash = window.location.hash.replace(/^#/, '')
		// only treat the hash as auth params when it actually carries a token,
		// otherwise we would mangle a plain anchor when rebuilding the URL
		const hashQuery = /(^|&)(access_token|token)=/.test(rawHash) ? new URLSearchParams(rawHash) : null

		const queryToken = hashQuery?.get('access_token') ?? hashQuery?.get('token')
			?? query.get('access_token') ?? query.get('token')
		const storageToken = window.localStorage.token
		token = queryToken ?? storageToken
		if (token == 'null') token = null

		// The token must not stay in the URL: it would leak as soon as the user
		// shares or bookmarks the link (and it is sent along as redirect_uri below).
		// Strip everything the auth callback appended and rewrite the URL in place.
		const authParams = [
			'access_token', 'token', 'token_type', 'expires_in', 'id_token', 'refresh_token',
			'refresh_expires_in', 'session_state', 'not-before-policy', 'scope', 'state', 'code',
		]
		authParams.forEach((p) => {
			query.delete(p)
			hashQuery?.delete(p)
		})
		const cleanQuery = query.toString()
		const cleanHash = hashQuery ? hashQuery.toString() : rawHash
		const cleanUrl = window.location.pathname
			+ (cleanQuery ? '?' + cleanQuery : '')
			+ (cleanHash ? '#' + cleanHash : '')
		if (queryToken) window.history.replaceState({}, document.title, cleanUrl)

		// TODO: decode the token, read the name and expiry and display somewhere

		// when forceLogin is true, we instruct MYS to show the login screen regardless of the current login state
		const forwardToAuthPage = async (forceLogin = false) => {
			console.log('resetting token and sending to auth')
			window.localStorage.token = null

			// TODO: this must be removed once mys auth works fully
			if (false) {
				window.location.href = settings.baseEndpoint.replace('//cma.', '//auth.')
				return
			}

			let url: string
			let query: any
			if (config.FEATURE_LOGIN_KEYCLOAK == 'true') {
				url = config.keycloakUrl + '/auth/realms/MyServices/protocol/openid-connect/auth'
				query = {
					response_type: 'token',
					client_id: 'contenthub-ui',
					redirect_uri: window.location.href,
					scope: 'profile',
					// TODO: this is not supported by keycloak - do we have a different solution?
					//       what we actually want to do is a logout
					forceLogin: forceLogin ? 'true' : 'false',
					// TODO: this is not supported by keycloak
					//       can we use the state to transport this??
					spaceId: window.location.href.match(/spaces\/([^/]+)/)?.[1],
					//state: '',
				}
			}
			else {
				// TODO: remove this mode once keycloak auth is activated
				// previously we used MYS as auth provider
				url = config.myservicesUrl + '/auth'
				query = {
					response_type: 'token',
					client_id: 'ContentHub',
					redirect_uri: window.location.href,
					scope: 'login+profile',
					// state: '',
					forceLogin: forceLogin ? 'true' : 'false',
					spaceId: window.location.href.match(/spaces\/([^/]+)/)?.[1],
				}
			}
			window.location.href = url + '?' + new URLSearchParams(query).toString()
		}

		// some pages dispatch a 401 event
		document.body.addEventListener('401', async (e: any) => {
			console.log('got 401', e?.detail)
			// 401 happened on a page that was the login target -> prevent loops
			// (the token is no longer in the URL, so we remember how we got here)
			if (queryToken) {
				window.alert('probable auth problem. got invalid token!')
				console.error('token', queryToken, e)
				return
			}
			await forwardToAuthPage(e?.detail?.byUser)
		})

		if (!token) {
			console.log('no token, forwarding to auth')
			await forwardToAuthPage()
			return
		}
		pathname = cleanUrl
	}
	else {
		throw new Error('Unknown mode: ' + mode)
	}

	if (!token) throw new Error('No token')

	if (window.localStorage.token != token || window.location.href.indexOf('mode=MyServices') > 0) {
		window.localStorage.token = token
		router.push(pathname)
	}

	Vue.component('mdi', MDI)
	Vue.component('ActionButton', ActionButton)
	Vue.component('Dialog', Dialog)
	// ATT: i would prefer not to have SystemTags global, but it had to be to make the
	//      extends on AssetFilter work, because otherwise we had some circular dependency
	Vue.component('SystemTags', SystemTags)
	Vue.component('ExtensionSlot', ExtensionSlot)

	const v = new Vue({
		router,
		render: h => h(App),
		provide() {
			return {
				settings
			}
		},
	}).$mount('#app')

	// we forward the router before event into the application, so each component may intercept it
	router.beforeEach((to, from, next) => {
		const app = v.$children[0] as any
		app.routerBeforeEach(to, from, next)
	})
}
init()
